export enum NotificationTypeEnum {
  REFERRAL = 'REFERRAL',
  REST_REPORT = 'REST_REPORT',
  PRESCRIPTION = 'PRESCRIPTION',
  OPINION = 'OPINION',
}
